import {
  DESKTOP_OFFSET_AFTER_HEADER,
  HEADER_OFFSET_SEARCH,
} from 'src/constants/header';

export const countFullDesktopOffset = (
  isHeaderBannerHidden: boolean,
  headerBannerOffset: number,
) => {
  if (isHeaderBannerHidden)
    return HEADER_OFFSET_SEARCH + DESKTOP_OFFSET_AFTER_HEADER;
  return (
    HEADER_OFFSET_SEARCH + DESKTOP_OFFSET_AFTER_HEADER + headerBannerOffset
  );
};
